import React from "react";
import { Grid } from "@material-ui/core";
import ArrowLink from "~/assets/img/icon/arrow-link.svg";
import ReactSVG from "react-svg";
import * as S from "./styles";
import { Creators as PromoActions } from "~/store/modules/promo/actions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import isWinnersPhase from "~/utils/isWinnersPhase";
import { useHistory } from "react-router-dom";

export default function Winners() {
  const dispatch = useDispatch();
  const history = useHistory();
  const winnerList = useSelector((state) => state.promo.listWinners.response?.lista) || [];
  const winnerList2 = useSelector((state) => state.promo.listWinners.response?.listaSemanal) || [];

  useEffect(() => {
    dispatch(PromoActions.getListWinners());
  }, [dispatch])

  useEffect(() => {
    if (!isWinnersPhase()) {
      history.push("/");
    }
  }, [history]);
  

  return (
    <section id="winners">
      <S.BG>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="space-between"
        >
          <S.Title>Parabéns aos nossos vencedores!</S.Title>
          <S.TableContainer id="oi">
            {/* Tabela dos Prêmios Instantâneos */}
            <S.TableWrapper>
              <S.TableHeader bgColor="#0D5BA8">Vencedores dos prêmios instantâneos</S.TableHeader>
              <S.StyledTable>
                <S.TableHead>
                  <S.TableRow>
                    <S.TableCell>Nome do(a) possível ganhador(a)</S.TableCell>
                    <S.TableCell>Cidade / Estado</S.TableCell>
                  </S.TableRow>
                </S.TableHead>
                <tbody>
                  {winnerList.map((winner, index) => (
                    <S.TableRow key={index}>
                      <S.TableData>{winner.NomeGanhador}</S.TableData>
                      <S.TableData>{winner.Cidade}/{winner.Estado}</S.TableData>
                    </S.TableRow>
                  ))}
                </tbody>
              </S.StyledTable>
            </S.TableWrapper>

            {/* Tabela do Concurso Bebê Johnson's */}
            <S.TableWrapper>
              <S.TableHeader bgColor="#F08929">Vencedores do Concurso Bebê Johnson's</S.TableHeader>
              <S.StyledTable>
                <S.TableHead>
                  <S.TableRow>
                    <S.TableCell>Nome do(a) possível ganhador(a)</S.TableCell>
                    <S.TableCell>Cidade / Estado</S.TableCell>
                  </S.TableRow>
                </S.TableHead>
                <tbody>
                  {winnerList2.map((winner, index) => (
                    <S.TableRow key={index}>
                      <S.TableData>
                      <S.Name>
                      {winner.NomeGanhador}
                        {winner.Instagram && (
                          <S.ArrowLink href={`https://instagram.com/${winner.Instagram?.replace('@', '')}`} rel="noreferrer noopener" target="_blank">
                            <ReactSVG src={ArrowLink} />
                          </S.ArrowLink>
                        )}
                      </S.Name></S.TableData>
                      <S.TableData>{winner.Cidade}/{winner.Estado}</S.TableData>
                    </S.TableRow>
                  ))}
                </tbody>
              </S.StyledTable>
            </S.TableWrapper>
          </S.TableContainer>
        </Grid>
      </S.BG>
    </section>
  );
}
